function ParseBaseUrl(){
    const url = "https://xeon-db-new.azurewebsites.net/graphql" //prod
    //const url = "https://dynamodb-dev.xeonsoftware.com/graphql" //dev
    //const url = "https://localhost:44363/graphql" //local
    //const url = "https://192.168.88.19:44363/graphql" //local
    return url;
}

export const API_URL = ParseBaseUrl()